import { render, staticRenderFns } from "./DailyReviewDataTable.vue?vue&type=template&id=42a8b849&scoped=true"
import script from "./DailyReviewDataTable.vue?vue&type=script&lang=js"
export * from "./DailyReviewDataTable.vue?vue&type=script&lang=js"
import style0 from "./DailyReviewDataTable.vue?vue&type=style&index=0&id=42a8b849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a8b849",
  null
  
)

export default component.exports